import React, { useEffect, useState } from "react";
import { Button, Table, Pagination, Select, Spin, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SearchBar from "../../screens/portfolioApp/portfolioList/SearchBar";
import "./landing-page.css";
import {
  fetchBrands,
  fetch_radius_per_miles,
} from "../../screens/portfolioApp/portfolio/commonApis";
import axiosInstance from "../../service/AxiosInstance";
import { useDrawer } from "../layout-components/menu/menuContext";
import moment from "moment";
import useValuationWarning from "../../hooks/useValuationWarning";
import WarningModal from "../../screens/valuation/homescreen/WarningModal";

const SearchResults = ({
  onPrevious,
  initialZipcode,
  initialBrand,
  initialRadius,
  handleOk,
  handlePostValuationAction,
  handleValuationClick,
  AllDealerData,
  setWarning,
  setIsModalOpen,
  showOverlay,
}) => {
  const columns = [
    {
      title: "Group",
      dataIndex: "Group",
      key: "Group",
      width: 220,
      sorter: (a, b) => a.Group?.localeCompare(b.Group),
      // sorter: (a, b) => a.Group?.replace(/[^a-zA-Z]/g, '')?.localeCompare(b.Group?.replace(/[^a-zA-Z]/g, '')),

    },
    {
      title: "Rooftop Name",
      dataIndex: "DealerName",
      key: "DealerName",
      width: 220,
      // sorter: (a, b) => a.DealerName?.replace(/[^a-zA-Z]/g, '')?.localeCompare(b.DealerName?.replace(/[^a-zA-Z]/g, '')),
      sorter: (a, b) => a.DealerName?.localeCompare(b.DealerName),
      render: (text, record) => (
        <a
          onClick={() =>
            handleDealerClick(record.DealerID, record.PrimaryDealerInfoID)
          }
        >
          {text}
        </a>
      ),
    },
    {
      title: "Alternate Name",
      dataIndex: "NavatarName",
      key: "NavatarName",
      width: 190,
      sorter: (a, b) => a.NavatarName?.localeCompare(b.NavatarName),
    },
    {
      title: "Brand(s)",
      dataIndex: "Brand",
      key: "Brand",
      width: 100,
      sorter: (a, b) => a.Brand?.localeCompare(b.Brand),
    },
    {
      title: "Units Sold(%)",
      dataIndex: "UnitsSold",
      key: "UnitsSold",
      width: 135,
      render: (value) => (value ? value.toFixed(1) + "%" : "0"),
      sorter: (a, b) => a.UnitsSold - b.UnitsSold,
    },
    {
      title: "State",
      dataIndex: "State",
      key: "State",
      width: 125,
      sorter: (a, b) => a.State?.localeCompare(b.State),
    },
    {
      title: "City",
      dataIndex: "City",
      key: "City",
      width: 130,
      sorter: (a, b) => a.City?.localeCompare(b.City),
    },
    {
      title: "Zipcode",
      dataIndex: "ZipCode",
      key: "ZipCode",
      width: 80,
      sorter: (a, b) => a.ZipCode - b.ZipCode,
    },
    {
      title: "Address",
      dataIndex: "Address",
      key: "Address",
      width: 180,
      // sorter: (a, b) => a.Address?.localeCompare(b.Address),
    },
  ];
  const { Option } = Select;

  const [zipcode, setZipcode] = useState(initialZipcode);
  const [radius, setRadius] = useState(initialRadius);
  const [group, setGroup] = useState("");
  const [state, setState] = useState([]);
  const [brand, setBrand] = useState(initialBrand);
  const [dealerData, setDealerData] = useState([]);
  const [dealerLoading, setDealerLoading] = useState(false);
  const [brandsList, setBrandsList] = useState([]);
  const [radiusPerMile, setRadiusPerMile] = useState([]);
  const [selectedDealerInfoId, setSelectedDealerInfoId] = useState(null);
  const [selectedDealerId, setSelectedDealerId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [isDealerClicked, setIsDealerClicked] = useState(false);
  const { dispatch } = useDrawer();

  const totalItems = searchResults.length;
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const handleSearch = async () => {
    setLoading(true);

    const queryParams = {
      zipcode_or_dealership: zipcode,
      mile: radius,
    };

    if (brand && brand.length > 0) {
      queryParams.brands = brand.join(",");
    }

    const queryString = Object.keys(queryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join("&");

    try {
      const { data } = await axiosInstance.get(`/navatar?${queryString}`);
      setSearchResults(data.DealersList);
    } catch (error) {
      console.error("Error fetching search results: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBrandsAndRadiusOptions = async () => {
    const brands = await fetchBrands();
    setBrandsList(brands);
    const data = await fetch_radius_per_miles();
    setRadiusPerMile(
      data?.map((num) => ({
        label: `${num} Miles`,
        value: num,
      }))
    );
  };

  const CreateNewValuation = async () => {
    try {
      const { data: response } = await axiosInstance.post(
        `/valuation`,
        {
          dealer_info_id: selectedDealerInfoId,
          name: "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm"),
          config_id: 1421,
          isInstantReport: true,
          dealer_id: selectedDealerId,
        },
        {
          params: {
            username: sessionStorage.getItem("user_name"),
          },
        }
      );

      if (response.Status) {
        const valuationId = response.Valuation_id;
        handlePostValuationAction(valuationId);
        if (handleValuationClick) {
          handleValuationClick();
        } else {
          handleOk(valuationId);
        }
      } else {
        message.warning(response.Message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDealerClick = (dealerId, dealerInfoID) => {
    if (!isDealerClicked) {
      setIsDealerClicked(true);
      setSelectedDealerInfoId(dealerInfoID);
      setSelectedDealerId(dealerId);
    }
  };

  const { handleValuation } = useValuationWarning(
    AllDealerData,
    selectedDealerId,
    "Estimate" + "_" + moment().format("DD MMM YYYY HH:mm"),
    CreateNewValuation,
    setShowWarningModal,
    setWarningMessage,
    setWarning,
    setIsModalOpen,
    showOverlay,
    selectedDealerInfoId
  );
  useEffect(() => {
    if (selectedDealerInfoId) {
      handleValuation();
    }
  }, [selectedDealerInfoId]);
  useEffect(() => {
    fetchBrandsAndRadiusOptions();
    handleSearch();
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  return (
    <Spin spinning={loading || isDealerClicked}>
      <div className="search-advanced">
        <Button
          onClick={onPrevious}
          type="link"
          icon={<ArrowLeftOutlined />}
          style={{ paddingLeft: "0px", color: "black" }}
        >
          Previous
        </Button>
        <SearchBar
          radiusPerMile={radiusPerMile}
          searchBy="radius"
          zipcode={zipcode}
          setZipcode={setZipcode}
          radius={radius}
          setRadius={setRadius}
          group={group}
          setGroup={setGroup}
          state={state}
          setState={setState}
          brand={brand}
          setBrand={setBrand}
          handleSearch={handleSearch}
          showDrawer={() => {}}
          brandsList={brandsList}
          dealerData={{ abc: "abc" }}
          dealerLoading={dealerLoading}
          showButton={false}
        />
        <div style={{ marginBottom: "7px" }}>Click on your dealership</div>
        <Table
          dataSource={searchResults}
          columns={columns}
          className="advance_table"
          pagination={false}
          scroll={{ y: 450 }}
          // pagination={{
          //   current: currentPage,
          //   pageSize: pageSize,
          //   total: totalItems,
          //   onChange: handlePageChange,
          //   showSizeChanger: true,
          //   pageSizeOptions: [
          //     ...Array.from({ length: 10 }, (_, i) => (i + 1) * 5),
          //     100,
          //     500,
          //     1000,
          //     2000,
          //   ],
          //   showTotal: (total, range) =>
          //     `${range[0]}-${range[1]} of ${total} items`,
          // }}
        />
      </div>
      {showWarningModal && (
        <WarningModal
          visible={showWarningModal}
          onClose={() => setShowWarningModal(false)}
          messageContent={warningMessage}
          onCreateValuation={CreateNewValuation}
        />
      )}
    </Spin>
  );
};

export default SearchResults;
